import React from 'react';
import PageTitle from '../PageTitle';
import { doRequest } from '../../helper';
import $ from 'jquery';

export default class FitIndiaManageVideos extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            items: [],
            response: null
        }
        this.update = this.update.bind( this );
        this.getPosts = this.getPosts.bind( this );
        this.batchUpdate = this.batchUpdate.bind( this );
        this.selectToggle = this.selectToggle.bind( this );

    }
    componentDidMount() {
        var status = this.props.match.params.status;
        if ( !status ) {
            status = "enabled";
        }
        this.getPosts( status );
    }
    componentWillReceiveProps( nextProps ) {
        var status = nextProps.match.params.status;
        if ( !status ) {
            status = "enabled";
        }
        this.getPosts( status );
    }
    batchUpdate( status ) {
        var ids = [];
        var createds = [];
        $( ".multi_select:checked" ).each( function() {
            ids.push( $( this ).attr( 'data-id' ) );
            createds.push( $( this ).attr( 'data-created' ) );
        } )
        var id = ids.join( ',' );
        var created = createds.join( ',' );

        if ( id == "" ) {
            alert( "No post selected" );
        } else {
            this.update( id, created, status );
        }

    }
    update( id, created, status, otherFlag, otherFlagValue ) {
        id = "" + id;
        $( ".loader" ).show();
        if ( otherFlagValue ) {
            otherFlagValue = 1;
        } else {
            otherFlagValue = 0;
        }

        var request = doRequest( 'cms-operations', {
            'action': 'update-video',
            'module': 'FitIndia',
            'model': 'video',
            'data': {
                'id': id,
                'status': status,
                'created': created,
                'otherFlag': otherFlag,
                'otherFlagValue': otherFlagValue
            }
        }, true );

        request.addEventListener( "load", function() {
            var response = this.responseText;
            $( ".loader" ).hide();
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    var ids = id.split( "," );
                    if ( !otherFlag ) {

                        ids.map( function( id_value ) {
                            $( "#post_" + id_value ).hide();
                        } )
                    }

                }
            } catch ( ex ) {

            }

        } );
    }
    selectToggle() {
        if ( $( ".allChecked" ).length > 0 ) {

            $( ".multi_select" ).prop( "checked", false );
            $( ".multi_select" ).removeClass( "allChecked" );

        } else {


            $( ".multi_select" ).prop( "checked", true );
            $( ".multi_select" ).addClass( "allChecked" );
        }

    }
    getPosts( status ) {

        var ref = this;
        ref.setState( { "items": [] } );
        var request = doRequest( 'cms-operations', {
            'action': 'list-videos',
            'module': 'FitIndia',
            'model': 'video',
            'data': {
                'direction': 'desc',
                'status': status,
                'limit': ref.state.limit
            }
        }, true )
        request.addEventListener( "load", function() {
            var response = this.responseText;
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    ref.setState( { "response": response, "items": response.items, "lastIndex": response.lastEvaluatedKey } );
                }
            } catch ( ex ) {

            }

        } );
    }
    render() {
        var response = this.state.response;
        var items = this.state.items;

        return (
            <div><PageTitle title="Fit India Campaign" bread="Fit India Campaign / Manage Videos" />
                <div className="wrapper wrapper-content">
                    <div className="wrapper wrapper-content">

                        <a className="btn btn-warning btn-xs" onClick={() => { this.batchUpdate( 'disable' ) }} type="button"><i className="fa fa-times"></i>&nbsp;Delete Selected</a>
                        &nbsp;&nbsp;<a href="javascript:void(0);" onClick={this.selectToggle}><i className="fa fa-check"></i>&nbsp;Select All Toggle</a>
                        &nbsp;
                        <br /><br />
                        <div className="row">
                            <div className="col-lg-12">
                                {items.map(( value, index ) => {
                                    
                                    var pmSpeech = false;
                                    var yogaSpeech = false;
                                    var yoga3d = false;
                                    
                                    if ( value.pmSpeech && value.pmSpeech == 1 ) {
                                        pmSpeech = true;
                                    } if ( value.yogaSpeech && value.yogaSpeech == 1 ) {
                                        yogaSpeech = true;
                                    } if ( value.yoga3d && value.yoga3d == 1 ) {
                                        yoga3d = true;
                                    }
                                    return ( <div class="file-box" key={index} id={"post_" + value.id}>
                                        <div class="file">
                                            <a href={value.url} target="_blank">
                                                <span class="corner"></span>

                                                <div class="image" style={{ "height": "auto" }}>
                                                    <img alt="image" class="img-responsive" src={value.thumbnail_url} />
                                                    <div className="image_caption">
                                                        <a href="javascript:void(0);" className="btn btn-warning btn-circle"
                                                            onClick={() => { this.update( value.id, value.created, 'disable' ) }} type="button">
                                                            <i className="fa fa-times"></i>
                                                        </a>
                                                    </div>
                                                    <a href="javascript:void(0);" style={{ "position": "absolute", "top": "10px", "left": "10px" }} className="btn btn-info btn-circle " type="button">
                                                        <input data-created={value.created} data-id={value.id} type="checkbox" className="multi_select" style={{ "margin": "2px" }} />
                                                    </a>
                                                </div>
                                                <div class="file-name">
                                                    {value.title}
                                                    <br />
                                                    <small>{value.created}</small>
                                                    <br />
                                                    <div className="form-group checkbox">

                                                        <label>
                                                            <input type="checkbox" defaultChecked={yogaSpeech} onClick={( element ) => { this.update( value.id, value.created, 'enable', 'yogaSpeech', element.target.checked ) }} ref={( yogaSpeech ) => { this.yogaSpeech = yogaSpeech }} value="" />
                                                            Yoga Speech
                                                                    </label><br />
                                                    <label>
                                                            <input type="checkbox" defaultChecked={pmSpeech} onClick={( element ) => { this.update( value.id, value.created, 'enable', 'pmSpeech', element.target.checked ) }} ref={( trending ) => { this.trending = trending }} value="" />
                                                            PM Speech
                                                                    </label><br />
                                                        <label>
                                                            <input type="checkbox" defaultChecked={yoga3d} onClick={( element ) => { this.update( value.id, value.created, 'enable', 'yoga3d', element.target.checked ) }} ref={( trending ) => { this.trending = trending }} value="" />
                                                            Yoga 3d
                                                                    </label>
                                                    </div>

                                                </div>
                                            </a>

                                        </div>
                                    </div> )

                                } )}

                            </div>
                        </div>

                    </div>
                </div>
            </div> );
    }
}


// WEBPACK FOOTER //
// ./src/Components/FitIndia/ManageVideos.jsx